<!--  支付抢购 -->
<template>
<div>
  <div v-if="bodyShow" class="rush-main">
      <div v-if="!isPay()">
        <img  class="img1" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-1.png" alt="" >
        <!-- form -->
        <div class="rush-bg">
            <div class="rush-form">
                <h5>（已加密,请放心填写）</h5>
                <input type="text" :class="(!name && !bool)?'on':''" v-model="name" :placeholder="(!name && !bool)?'此项不能为空请输入':'请输入您的姓名'" />
                <input type="text" :class="(!phone && !bool)?'on':''" v-model="phone" :placeholder="(!phone && !bool)?'此项不能为空请输入':'请输入您的电话'" />
                <div class="xy" @click="checkBool=!checkBool">
                    <img v-if="!checkBool" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/check.png" alt="">
                    <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/checked.png" alt="">
                    自动输入历史手机号<span>《个人信息授权与保护声明》</span>
                </div>
                <a  @click="validatorHandle()" class="subBtn">限时抢购</a>
                <p >温馨提示：支付后，请添加<span style="font-weight:bold;">【新精英职场加速器】</span>服务号以免错失专属服务群，上课提醒、实时答疑、测评礼包等专享服务</p>
            </div>
        </div>
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-3.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-4.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-5.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-6.png" alt="" >
        <!-- form -->
        <div class="rush-bg2">
            <div class="rush-form">
                <h5>（已加密,请放心填写）</h5>
                <input type="text" :class="(!name && !bool)?'on':''" v-model="name" :placeholder="(!name && !bool)?'此项不能为空请输入':'请输入您的姓名'" />
                <input type="text" :class="(!phone && !bool)?'on':''" v-model="phone" :placeholder="(!phone && !bool)?'此项不能为空请输入':'请输入您的电话'" />
                <div class="xy" @click="checkBool=!checkBool">
                    <img v-if="!checkBool" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/check.png" alt="">
                    <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/checked.png" alt="">
                    自动输入历史手机号<span>《个人信息授权与保护声明》</span>
                </div>
                <a  @click="validatorHandle()" class="subBtn">限时抢购</a>
                <p >温馨提示：支付后，请添加<span style="font-weight:bold;">【新精英职场加速器】</span>服务号以免错失专属服务群，上课提醒、实时答疑、测评礼包等专享服务</p>
            </div>
        </div>
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-7.png" alt="" >
      </div>
      <div v-else>
        <img  class="img1" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-1.png" alt="" >
        <!-- form -->
        <div class="rush-bg-new">
            <div class="rush-form">
                <h5>（已加密,请放心填写）</h5>
                <input type="text" :class="(!name && !bool)?'on':''" v-model="name" :placeholder="(!name && !bool)?'此项不能为空请输入':'请输入您的姓名'" />
                <input type="text" :class="(!phone && !bool)?'on':''" v-model="phone" :placeholder="(!phone && !bool)?'此项不能为空请输入':'请输入您的电话'" />
                <input type="text" class="code" :class="(!code && !bool)?'on':''" v-model="code" :placeholder="(!phone && !bool)?'此项不能为空请输入':'请输入验证码'" />
                <a @click="getCodeHandle()" :class="['code-btn',canClick?'':'disabled']">{{codeText}}</a>
                <div class="xy" @click="checkBool=!checkBool">
                    <img v-if="!checkBool" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/check.png" alt="">
                    <img v-else src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/checked.png" alt="">
                    自动输入历史手机号<span>《个人信息授权与保护声明》</span>
                </div>
                <a  @click="validatorHandle()" class="subBtn">限时抢购</a>
                <p >温馨提示：支付后，请添加<span style="font-weight:bold;">【新精英职场加速器】</span>服务号以免错失专属服务群，上课提醒、实时答疑、测评礼包等专享服务</p>
            </div>
        </div>
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-3.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-4.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-5.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-6.png" alt="" >
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-7.png" alt="" >
      </div>
      <van-popup class="qr-code-pop" v-model="qrcodeShow" >
        <div class="qr-code">
            <div class="title">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/left-icon.png" />
                <span>领取成功</span>
                <img src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/right-icon.png" />
            </div>
            <!--  -->
            <div class="p">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/sj.png" />
                识别二维码添加班主任微信
            </div>
            <!-- <div class="p">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/sj.png" />
                打开微信，点击右上角扫一扫
            </div> -->
            <div class="p on">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/sj.png" />
                进入专属服务群领取
            </div>
            <img class="line" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/line.png" />
            <p>请按照上面步骤激活课程</p>
            <h5>(*未成功激活不能参加学习)</h5>
            <img v-if="isPay()" class="qr" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/qrcode_new1.png" />
            <img v-else class="qr" src="https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/qrcode_new2.png" />
        </div>
      </van-popup>
    </div>
</div>
</template>

<script>

import axios from 'axios'
import { wxpay,h5wxpay,orders,checkpay,toutiao_track,check_phone} from "@/api/other";
import { getStorage, setStorage, deepCopy,deleteStorage, isWeixin,queryString,delParam,isMain } from "@/utils/tools";
import { phoneValidation,events } from "@/utils/validation";

export default {
    data(){
        return{
            data:{},
            bodyShow:false,
            checkBool:false,
            name:'',
            phone:null,
            code:'',
            bool:true,
            qrcodeShow:false,
            qrType:'',
            isBuy: false,
            // 倒计时
            codeText: '发送验证码',
            time: 60,
            canClick: true,
            sms_id:null,
            Url:isMain()? "https://open.xjy.cn/api" : "https://open.xjy.cn/dev"
        }
    },
    mounted(){
        
    },
    methods:{
        // 获取验证码
        getCodeHandle(){
            // 验证手机号是否正确
            if(!phoneValidation(this.phone)){
                this.$toast('请输入正确的手机号！');
                return
              }
            //   倒计时
              events(this.codeText, this.time, this.canClick, (codeText, time, canClick) => {
                this.codeText = codeText;
                this.time = time;
                this.canClick = canClick;
              });
              
              if(this.canClick){
                   let params = new URLSearchParams();
                    params.append('mobile', this.phone);
                    axios.post(this.Url+'/cms/send_sms', params).then(success=>{
                        if(success.data.error>0){
                            self.$toast(success.data.msg);
                            return
                        }
                        if(success.data.error==0){
                            this.sms_id = success.data.sms_id;
                        }
                    });
              }
        },
        // 是否付费
        isPay(){
            return this.qrType=='NU'?true:false
        },
        validatorHandle(){
            let self = this;

            if(!self.name || !self.phone){
                self.$toast('用户名或密码不能为空！');
                self.bool = false;
                return
            }
            if(this.isPay()){
                if(!self.code){
                    self.$toast('验证码不能为空！');
                    self.bool = false;
                    return
                }
            }
            
            if(!phoneValidation(self.phone)){
                self.$toast('请输入正确的手机号！');
                return
            }
            if(!self.checkBool){
                self.$toast('请先同意《个人信息授权与保护声明》！');
                return
            }
            if(self.checkBool){
                setStorage(self.$route.path, 'userObj', {
                    name:self.name,
                    phone:self.phone,
                    checkBool:self.checkBool
                });
            }else{
                deleteStorage(self.$route.path);
            }
            if(this.isPay()){
                // 验证验证码是否正确
                let params = new URLSearchParams();
                params.append('code', this.code);
                params.append('sms_id', this.sms_id);
                axios.post(this.Url+'/cms/check_sms', params).then(success=>{
                    if(success.data.error>0){
                        this.$toast(success.data.msg);
                        return
                    }
                    this.saveInfo();
                });
            }else{
                this.saveInfo();
            }
            

        },
        // 提交信息
        saveInfo(){
            let self = this;
            // 验证是否存在手机号
            check_phone({
                phone:self.phone
            }).then(res=>{
                if (res.code == 10002) {
                    this.$toast(res.data.msg);
                    return ;
                }
                if(res.exist){
                    this.$toast('本课程仅限新精英新用户领取！');
                    return ;
                }
                function send_crm() {
                    let params = new URLSearchParams();
                    params.append('phone', self.phone);
                    params.append('source', "9.9转化营");
                    params.append('name', self.name);
                    axios.post(self.$Url+'crm/', params).then(success=>{
                        if(success.status!=200){
                            self.$toast(success.statusText);
                            return
                        }
                        if(success.data.status==1){
                            self.$toast('提交成功！');
                        }
                    });

                

                    // toutiao_track({
                    //     referer: window.location.href
                    // }).then(data=>{
                    // });
                    self.payHandle();
                }

                window.onOK = function() {
                    send_crm();
                }

                window.onError = function() {
                    send_crm();
                }

                if(typeof sendPage == 'function') {
                    sendPage(this.phone, this.name);
                } else {
                    send_crm();
                }
            }); 
        },
        // 支付
        payHandle() {
            //调用加载中
            this.$emit('loadingHandle',true,"支付加载中...");

            if(isWeixin()) {
                wxpay({
                   name:this.name,
                   phone:this.phone,
                   referer:window.location.href,
                   buy_id:this.isPay()?2:4
                }).then(data => {
                    let data_ = eval("(" + data.jsApiParameters + ")");
                    let jsApiCall = () => {
                        WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
                            //关闭加载中
                            this.$emit('loadingHandle',false);
                            WeixinJSBridge.log(rest.err_msg);
                            if (rest.err_msg == "get_brand_wcpay_request:ok") {
                                this.$toast('支付成功');
                                // this.$router.push('/rush_purchase_success');
                                this.qrcodeShow = true;
                            } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                                alert("支付取消");
                            } else {
                                alert("支付失败");
                            }
                        });
                    };

                    if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
                    } else if (document.attachEvent) {
                        document.attachEvent("WeixinJSBridgeReady", jsApiCall);
                        document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
                    }
                    } else {
                        jsApiCall();
                    }
                });
            } else {
                h5wxpay({
                   name:this.name,
                   phone:this.phone,
                   referer:window.location.href,
                   buy_id:this.isPay()?2:4
                }).then(data => {
                    let mweb_url = data.h5Parameters.mweb_url;
                    let trade_no = data.h5Parameters.trade_no;

                    // 缓存trade_no 用于查询订单是否支付成功
                    setStorage(this.$route.path, 'trade_no',trade_no)
                    let seperator = window.location.href.indexOf('?') > 0 ? '&' : '?';
                    let page_url = encodeURIComponent(window.location.href.replace(/[&\?]trade_no=[^&]+/g, '') + seperator + 'trade_no=' + trade_no);
                    window.location.href = `${mweb_url}&redirect_url=${page_url}`;
                });
                
            }
            
        },
        pullData(){
            if(isWeixin()) {
                orders({
                    buy_id:this.isPay()?2:4
                }).then((data)=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    this.data = data;
                    this.qrType = this.$route.query.sou;
                    document.title = "7天职场“高薪突围”计划";
                    if(data.orders.length>0){
                        this.isBuy = true;
                        this.qrcodeShow = true;
                        this.bodyShow = true;
                        // this.$router.push('/rush_purchase_success');
                        return
                    }
                    
                    this.bodyShow = true;
                    
                    let obj = getStorage(this.$route.path, 'userObj');
                    if(obj && String(obj)!='{}'){
                        this.name = obj.name;
                        this.phone = obj.phone;
                        this.checkBool = obj.checkBool;
                    }
                });
            } else {
                //  || 
                let trade_no =queryString(location.href,'trade_no')?queryString(location.href,'trade_no'):getStorage(this.$route.path, 'trade_no');
                checkpay({
                    trade_no: trade_no
                }).then((data=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    this.data = data;
                    this.qrType = this.$route.query.sou;
                    document.title = "7天职场“高薪突围”计划";
                    if(data.is_buy){
                        this.isBuy = true;
                        this.qrcodeShow = true;
                        this.bodyShow = true;
                        // this.$router.push('/rush_purchase_success');
                        return
                    }
                    
                    this.bodyShow = true;
                    let obj = getStorage(this.$route.path, 'userObj');
                    if(obj && String(obj)!='{}'){
                        this.name = obj.name;
                        this.phone = obj.phone;
                        this.checkBool = obj.checkBool;
                    }
                }));
            }
            
        },
        addScript: function() {
            let jquery_url = 'https://statics-cdn.xjy.cn/js/jquery-2.1.4.min.js';

            if(!window.jQuery) {
                let script1 = document.createElement('script');
                script1.type = 'text/javascript';
                script1.src = jquery_url;
                document.getElementsByTagName('head')[0].appendChild(script1);
            }


            let mantis_url = ['ff1','ff2'].indexOf(this.$route.query.sou) > - 1 ? 'https://chatn9.bjmantis.net/chat/js/dist/mantis.min.js?6375#5f1666f730b02403751e31fc' : 'https://chatn9.bjmantis.net/chat/js/dist/mantis.min.js?6375#5f16670ba95cf511bc056a34';

            if(!window.mantis) {
                let script2 = document.createElement('script');
                script2.type = 'text/javascript';
                script2.src = mantis_url;
                document.getElementsByTagName('head')[0].appendChild(script2);
            }
        },
    },
    created(){
        // this.addScript();
        let trade_no =queryString(location.href,'trade_no')?queryString(location.href,'trade_no'):getStorage(this.$route.path, 'trade_no');
        if(queryString(location.href,'trade_no')){
            //调用加载中
            this.$emit('loadingHandle',true,"支付结果查询中...");
            setTimeout(()=>{
                this.pullData();
                //关闭加载中
                this.$emit('loadingHandle',false);
            },5000);
        }else{
            this.pullData();
        }
    }
}
</script>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed; // 鼠标变化
  opacity: .6;
  color:#ffffff !important;
}
input::-webkit-input-placeholder { 
/* WebKit browsers */ 
  color: rgba(255, 255, 255, .5); 
} 
input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
  color: rgba(255, 255, 255, .5); 
} 
input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
  color: rgba(255, 255, 255, .5); 
} 
input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
  color: rgba(255, 255, 255, .5); 
}
.rush-main{
    background-color: #ffffff;
    text-align: center;
    img{
        width: 100%;
        max-width: 750px;
    }
    .rush-bg{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-2.png') no-repeat center;
        background-size: 100% 100%;
        padding:171px 30px 52px;
    }
    .rush-bg-new{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/1-2.png') no-repeat center;
        background-size: 100% 100%;
        padding:101px 30px 72px;
    }
    .rush-bg2{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/media_landing_page/9-8.png') no-repeat center;
        background-size: 100% 100%;
        padding:221px 30px 72px;
    }
    .rush-form{
        padding: 0px 20px 52px;
        border-radius:16px;
        p{
            font-size:19px;
            color:#ffffff;
            line-height:31px;
            width: 590px;
            margin:40px auto 0;
            text-align:left;
        }
        .title{
            font-size:28px;
            color:#333333;
            line-height:1;
            margin-bottom:20px;
            text-align:left;
            font-weight:bold;
        }
        .label{
            text-align:left;
            font-size:20px;
            color:#333333;
            margin-bottom:45px;
            display:flex;
            align-items:center;
            img{
                width:64px;
                height:28px;
                margin-right:10px;
            }
        }
        h5{
            font-size: 20px;
            color: rgba(255, 255, 255, .8);
            line-height:1;
            margin-bottom: 20px;
            text-align: left;
            padding-left: 49px;
            span.c6{
                color:#C6C6C6;
            }
            span.red{
                color:#FF0000;
            }
        }
        input{
            width: 540px;
            height: 83px;
            line-height: 83px;
            border:2px solid rgba(255, 255, 255, .6);
            background-color: rgba(255, 255, 255, .3);
            margin-bottom: 21px;
            padding-left: 20px;
            color: #ffffff;
            box-sizing: border-box;
            border-radius: 47px;
            font-size: 26px;
        }
        input.code{
            width: 320px;
        }
        a.code-btn{
            display: inline-block;
            border:2px solid rgba(255, 255, 255, .6);
            background-color: rgba(255, 255, 255, .3);
            width: 200px;
            height: 83px;
            line-height: 83px;
            box-sizing: border-box;
            border-radius: 47px;
            font-size: 26px;
            color: #FC9426;
            margin-left: 20px;
        }
        input.on{
            border:2px solid #FF0000;
        }
        input.on::-webkit-input-placeholder { 
            /* WebKit browsers */ 
            color: #FF0000; 
        } 
        input.on:-moz-placeholder { 
            /* Mozilla Firefox 4 to 18 */ 
            color: #FF0000; 
        } 
        input.on::-moz-placeholder { 
            /* Mozilla Firefox 19+ */ 
            color: #FF0000; 
        } 
        input.on:-ms-input-placeholder { 
            /* Internet Explorer 10+ */ 
            color: #FF0000; 
        }
        input:focus{
            border:2px solid rgba(255, 255, 255, .5);
            background-color: rgba(255, 255, 255, .5);
        }
        .xy{
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: rgba(255, 255, 255, .8);
            font-weight:bold;
            margin-bottom: 34px;
            padding-left: 49px;
            span{
                color: rgba(255, 196, 34, .81);
            }
            img{
                width: 24px;
                height: 24px;
                margin-right: 30px;
                background-color: rgba(255, 255, 255, 1);
            }
        }
        .subBtn{
            display: block;
            width: 570px;
            line-height: 83px;
            color: #ffffff;
            background: linear-gradient(90deg, #FC9426, #FFC622);
            border-radius: 47px;
            margin: 0 auto;
            font-size: 34px;
        }
    }
}
.qr-code{
    width:750px;
    height:937px;
    background: url('https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/qr-bg.png') no-repeat center;
    background-size: 100% 100%;
    padding:160px 94px 357px;
    .title{
        display:flex;
        font-size:46px;
        color:#FF8D1B;
        text-align:center;
        align-items: center;
        justify-content: center;
        line-height:1;
        margin-bottom:60px;
        span{
            margin:0 18px;
        }
        img{
            width:43px;
            height:16px;
        }
    }
    .p{
        font-size:30px;
        color:#061C2A;
        line-height:1;
        margin-bottom:40px;
        text-align:left;
        padding-left:17px;
        display: flex;
        align-items: baseline;
        img{
            width:18px;
            height:20px;
            margin-right:15px;
        }
    }
    .p.on{
        margin-bottom:50px;
    }
    .line{
        width:564px;
        height:5px;
        margin:0px auto 30px;
    }
    p{
        font-size:24px;
        color:#061C2A;
        line-height:1;
        margin-bottom:10px;
    }
    h5{
        font-size:28px;
        color:#2896D2;
        line-height:1;
    }
    .qr{
        width:230px;
        height:230px;
        margin-top:20px;
    }
}
</style>
<style lang="scss">
.qr-code-pop{
    background:transparent;
}
</style>